module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticStyle: {
      "direction": "rtl"
    }
  }, [_vm._v(_vm._s(_vm.decodedQuestion))]), _vm._v(" "), _c('ul', _vm._l((_vm.choices), function(choice) {
    return _c('li', [_c('button', {
      class: choice.classes,
      staticStyle: {
        "direction": "rtl"
      },
      attrs: {
        "disabled": _vm.isPaused
      },
      on: {
        "click": function($event) {
          return _vm.answer(choice)
        }
      }
    }, [_vm._v(_vm._s(_vm.decode(choice.text)))])])
  }), 0), _vm._v(" "), (_vm.isPaused) ? _c('button', {
    on: {
      "click": _vm.advance
    }
  }, [_vm._v("שאלה הבאה")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cb12cfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Questions.vue
// module id = 45
// module chunks = 0